<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="700">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-book</v-icon>
            {{ edit ? "Editar" : "Incluir" }} Material
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form" v-if="visible">
            <v-row class="justify-center mt-7">
              <v-col cols="12">
                <v-text-field
                  v-model="content.descricao"
                  label="Descrição*"
                  counter="60"
                  maxlength="60"
                  dense
                  outlined
                  :rules="[(v) => $required(v)]"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  v-model="content.formacao"
                  :items="listFormacoes"
                  label="Formação*"
                  item-text="formacao"
                  item-value="id"
                  outlined
                  dense
                  :rules="[(v) => $required(v)]"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12">
                <sigfoco-upload-file
                  :size="12"
                  :maxSize="100"
                  :formats="'.pdf, .docx, .png, .jpeg, .jpg, .bmp, .mp3, .mp4, .zip'"
                  :previewInsideButton="false"
                  label="Enviar arquivo"
                  :ref="'uploadFileComponent_'"
                  v-model="arquivoTemporario"
                  @input="adicionarAnexo"
                  position="left"                
                  />
              </v-col>
            </v-row>
            <v-row v-if="arquivos.length" class="d-flex justify-center">
              <v-col cols="12">
                <span class="small">Anexos</span>
                <div class="anexos-box">
                  <div
                    v-for="(file, index) in arquivos"
                    :key="index"
                    class="anexo-item d-flex justify-space-between align-center px-3 py-2"
                  >
                    <span>
                      {{ file.name || file.nomeExibicao }} 
                      ({{ ((file.size || file.tamanho) / 1024).toFixed(0) }}K)
                    </span>
                    <v-icon
                      small
                      color="grey darken-2"
                      style="cursor: pointer"
                      @click.stop="removerAnexo(index)"
                    >
                      mdi-close
                    </v-icon>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </div>
        <sigfoco-buttons
          actionText="Salvar"
          @click="salvar()"
          @cancel="$emit('onClose')"
        ></sigfoco-buttons>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { Material } from '~/commons/classes/material';
import { DialogProps } from '~/commons/classes/dialog-props';
import ManterMaterialService from '@/services/manter-material.service';
import ManterFormacaoService from '@/services/manter-formacao.service';

export default {
  props: new DialogProps(Material),
  mixins: [ManterMaterialService, ManterFormacaoService],
  data: () => ({
    form: {
      arquivos: {}
    },
    listFormacoes: [],
    arquivoTemporario: null
  }),
  created() {
    if (!Array.isArray(this.content.arquivos)) {
      this.$set(this.content, 'arquivos', []);
    }
  },
  computed: {
    arquivos() {
      return Array.isArray(this.content.arquivos) ? this.content.arquivos : [];
    }
  },
  methods: {
    adicionarAnexo(file) {
      const MAX_SIZE_MB = 10;
      if (!file || !(file instanceof File)) return;
      if (file.size > MAX_SIZE_MB * 1024 * 1024) {
        this.$swal({
          text: `O arquivo excede o tamanho máximo de ${MAX_SIZE_MB}MB.`,
          type: 'warning',
          confirmButtonText: 'OK'
        });
        return;
      }
      if (!Array.isArray(this.content.arquivos)) {
        this.$set(this.content, 'arquivos', []);
      }
      this.content.arquivos.push(file);
      this.arquivoTemporario = null;
    },
    removerAnexo(index) {
      if (Array.isArray(this.content.arquivos)) {
        this.content.arquivos.splice(index, 1);
      }
    },
    payload() {
      const formData = new FormData();
      const materialId = this.content.id;
      const formacaoId = this.content.formacao?.id ?? this.content.formacao ?? null;
      formData.append('materialId', materialId);
      const comandoPayload = {
        id: materialId,
        formacaoId: formacaoId,
        descricao: this.content.descricao,
        materiais: this.content.arquivos
      };
      formData.append('comando', JSON.stringify(comandoPayload));
      if (Array.isArray(this.content.arquivos)) {
      this.content.arquivos.forEach((arquivo) => {
      if (arquivo.id) {
        formData.append('arquivos', new Blob([]));
      } else {
        formData.append('arquivos', arquivo);
      }
      });
      }

    return formData;
  },
    salvar() {
      if (!this.$validarFormulario()) return;
      const qtdArquivos = Array.isArray(this.content.arquivos) ? this.content.arquivos.length : 0;

        if (qtdArquivos < 1) {
          this.$notifyError("É necessário inserir ao menos um arquivo para manter o registro.");
          return;
        }
        if (qtdArquivos > 5) {
          this.$notifyError("Você só pode anexar no máximo 5 arquivos por material.");
          return;
        }
      this.$swal({
        text: "Deseja confirmar essa operação?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
      }).then(() => {
        const formData = this.payload();
        const formacaoId = this.content.formacao?.id ?? this.content.formacao ?? null;
        // 👇 Depuração: mostra o que está sendo enviado
        for (let pair of formData.entries()) {
          console.log(pair[0], pair[1]);
        }

        const request = this.edit
          ? this.$editar(this.content.id, formData)
          : this.$cadastrar(formacaoId, formData);

        request.then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.$emit("onClose");
          this.$emit("onSave");
        });
      });
    },
    carregarAnexos() {
      if (!Array.isArray(this.content.arquivos)) {
        this.$set(this.content, 'arquivos', []);
      }
      if (Array.isArray(this.form.arquivos)) {
        this.content.arquivos = [...this.form.arquivos];
      }
    }
  },
  mounted() {
    this.$buscarFormacao().then(({ data }) => {
      this.listFormacoes = data.lista;
    });
  }

}
</script>
<style scoped>
  .anexos-box {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 10px;
  background-color: #fff;
  margin-top: 10px;
}

.anexo-item {
  background-color: #f4f4f6;
  border-radius: 4px;
  margin-bottom: 6px;
  color: #555;
  font-size: 14px;
}

  </style>